'use client';

import { DashboardSkeleton } from '@/components/ui/loading';
import { useRouter } from 'next/navigation';
import { useStores } from '@/store/hooks/useStore';
import { useEffect } from 'react';

export default function Home() {
  const stores = useStores();
  const [isUserLoading, hasUserInfo] = [
    stores.userStore.isUseInfoLoading,
    !!stores.userStore.userInfo,
  ];
  const router = useRouter();

  useEffect(() => {
    if (isUserLoading) {
      return;
    }
    if (hasUserInfo) {
      router.push('/dashboard');
    } else {
      router.push('/auth');
    }
  }, [isUserLoading, hasUserInfo]);

  return (
    <div className="w-full h-100vh flex items-center justify-center">
      <DashboardSkeleton />
    </div>
  );
}
